import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import BlueprintIcon from '../../../../../../BlueprintIcon';

type ConfirmationStepHeaderProps = {};

export const ConfirmationStepHeader: FunctionComponent<ConfirmationStepHeaderProps> = () => {
    return (
        <section
            className={styles.confirmationStepHeader}
            aria-labelledby="confirmation-step-header"
        >
            <BlueprintIcon icon={'CheckMarkCircle'} className={styles.confirmedIcon} />
            <h1 id="confirmation-step-header" className={styles.checkoutStepHeader}>
                Application Sent
            </h1>
        </section>
    );
};
